module.exports = __webpack_public_path__ + "img/CON2.80d0c830.png";